import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import "./FAQ.css";

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

const faqs = [
  {
    question: "Who is the best gastroenterologist in Kompally, Hyderabad?",
    answer:
      "Krisara Gastro and Liver Clinic is led by Dr. B. Shruti Sagar, one of Kompally’s most trusted and experienced gastroenterologists, specializing in advanced endoscopy, liver treatment, and comprehensive digestive care.",
  },
  {
    question: "What digestive and liver diseases do you treat at Krisara Gastro?",
    answer:
      "We offer solutions for all major GI and liver conditions: acid reflux (GERD), fatty liver, hepatitis, constipation, chronic diarrhoea, abdominal pain, IBS, ulcerative colitis, Crohn’s disease, liver cirrhosis, pancreatitis, gallbladder issues, and colon cancer screening.",
  },
  {
    question: "Where is Krisara Gastro and Liver Clinic located?",
    answer:
      "Our clinic is conveniently located at Fair Mount, Kompally, Hyderabad, Telangana, easily accessible from Medchal, Bowenpally, Suchitra, Alwal, and surrounding North Hyderabad areas.",
  },
  {
    question: "Can I book a same-day appointment with a gastroenterologist in Hyderabad?",
    answer:
      "Yes! Krisara Gastro offers fast, same-day and next-day appointments with Dr. Shruti Sagar for urgent gut and liver issues in Kompally, Hyderabad.",
  },
  {
    question: "What advanced tests and procedures are available at Krisara Gastro?",
    answer:
      "We provide cutting-edge diagnostic and therapeutic services: Upper GI endoscopy, Colonoscopy, ERCP, Endoscopic ultrasound (EUS), Balloon and capsule enteroscopy, 24-hour pH monitoring, Esophageal manometry, and Liver function testing. All procedures use the latest equipment for maximum accuracy and patient safety.",
  },
  {
    question: "Is Krisara Gastro suitable for international or NRI patients?",
    answer:
      "Absolutely. Many international and NRI patients choose Krisara for expert consultations, second opinions, and fast-track diagnostics. We offer telemedicine and can assist with medical tourism needs in Hyderabad.",
  },
  {
    question: "How do I know if I need to see a gastroenterologist?",
    answer:
      "Consult a gastro specialist if you have long-standing digestive complaints: persistent heartburn, unexplained weight loss, frequent bowel changes, blood in stool, severe abdominal pain, chronic liver issues, or jaundice.",
  },
  {
    question: "Does Krisara offer colon cancer screening in Hyderabad?",
    answer:
      "Yes, we provide state-of-the-art colonoscopy for colon cancer screening and prevention for all adults over 45 or at higher risk due to family history and symptoms.",
  },
  {
    question: "What are symptoms of liver disease I should watch for?",
    answer:
      "Common liver disease signs include jaundice (yellow eyes/skin), chronic fatigue, swelling in legs/abdomen, unexplained weight loss, persistent nausea, and changes in urine or stool color.",
  },
  {
    question: "How much does an endoscopy or colonoscopy cost in Hyderabad?",
    answer:
      "At Krisara Gastro, we offer transparent, competitive pricing for all major procedures. Contact us for an exact quote or special offers for Kompally and Telangana residents.",
  },
  {
    question: "What languages does Krisara Gastro staff speak?",
    answer:
      "Our team fluently speaks English, Telugu, Hindi, and understands all regional dialects—making every patient feel comfortable and understood.",
  },
  {
    question: "How do I book an appointment at Krisara Gastro and Liver Clinic?",
    answer:
      "Appointments can be booked via phone/WhatsApp (+91-9959981290), email (sagar1292@gmail.com), or through our online form. Walk-ins for urgent cases are also welcome, though prior booking is preferred.",
  },
  {
    question: "Do you provide pediatric gastroenterology care?",
    answer:
      "Yes, Krisara Gastro offers specialist GI care for children and teens, including management of recurrent tummy aches, food intolerances, and chronic diarrhoea.",
  },
  {
    question: "Are walk-in consultations available for sudden stomach pain in Kompally?",
    answer:
      "Our clinic welcomes walk-ins and provides priority attention for emergency symptoms in all Kompally and North Hyderabad residents.",
  },
  {
    question: "Can I get a second opinion for my liver or gut condition?",
    answer:
      "Dr. Shruti Sagar provides expert second opinions, digital report reviews, and clear guidance for complex liver and digestive issues.",
  },
];
export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0); // open the first by default
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setIsVisible(true);
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };
  return (
    <div
      ref={sectionRef}
      className={`faq-container ${isVisible ? "animate" : ""}`}>
      {/* SEO Schema */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>
      <h2 className="faq-title fade-up" style={{ transitionDelay: "0.2s" }}>
        Frequently Asked Questions
      </h2>
      <p className="faq-subtitle fade-up" style={{ transitionDelay: "0.4s" }}>
        Clear answers to the most common queries about our gastro care in
        Kompally, Hyderabad—appointments, procedures, preparation, insurance,
        and recovery. Explore quick guidance below or contact the clinic for
        personalized support.
      </p>
      <a href="tel:+911234567890">
  <button
    className="faq-button fade-up"
    style={{ transitionDelay: "0.6s" }}>
    Reach Out to Us
  </button>
</a>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="faq-item fade-up"
            style={{ transitionDelay: `${0.8 + index * 0.1}s` }}>
            <div className="faq-question" onClick={() => toggleFAQ(index)}>
              <span>{faq.question}</span>
              <span className="faq-icon">
                {openIndex === index ? "−" : "+"}
              </span>
            </div>
            {openIndex === index && (
              <div className="faq-answer fade-in">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}